/** The state of a record's clock (13 §13.2). */
export type ClockState = 'on_track' | 'at_risk' | 'breached';

const MIN = 60_000;
const HOUR = 60 * MIN;
const DAY = 24 * HOUR;

/** "3 d 4 h", "5 h 12 min", "42 min", "<1 min". Negative spans count as zero. */
export function formatDuration(ms: number): string {
  const span = Math.max(0, Math.floor(ms));
  if (span < MIN) return '<1 min';
  if (span < HOUR) return `${Math.floor(span / MIN)} min`;
  if (span < DAY) {
    const h = Math.floor(span / HOUR);
    const m = Math.floor((span % HOUR) / MIN);
    return m === 0 ? `${h} h` : `${h} h ${m} min`;
  }
  const d = Math.floor(span / DAY);
  const h = Math.floor((span % DAY) / HOUR);
  return h === 0 ? `${d} d` : `${d} d ${h} h`;
}

/** Elapsed time since an ISO timestamp, or null when the timestamp is not a date. */
export function timeInState(
  sinceIso: string,
  now: number | Date = Date.now(),
): { ms: number; label: string } | null {
  const since = Date.parse(sinceIso);
  if (Number.isNaN(since)) return null;
  const ms = Math.max(0, (typeof now === 'number' ? now : now.getTime()) - since);
  return { ms, label: formatDuration(ms) };
}

export const CLOCK_LABEL: Record<ClockState, string> = {
  on_track: 'on track',
  at_risk: 'at risk',
  breached: 'breached',
};
